<template>
    <Modal v-model="showModal" title="Change Password" footer-hide :before-close="handleReset">
        <div>
            <ErrorMessages v-if="errorMessages.length" ref="ErrorMessages" :errors="errorMessages" />
            <Form
                ref="forgotPasswordForm"
                class="change-pass-form"
                :model="formData"
                :rules="formRules"
                label-position="top"
            >
                <FormItem label="Current Password" prop="old_password">
                    <Input v-if="!password.show_old_password" v-model="formData.old_password" type="password" />
                    <Input v-else v-model="formData.old_password" type="text" />
                    <Icon v-if="password.show_old_password" type="md-eye" @click="toggleOldPassword"></Icon>
                    <Icon type="md-eye-off" v-else @click="toggleOldPassword"></Icon>
                </FormItem>

                <FormItem label="New Password" prop="new_password">
                    <Input v-if="!password.show_new_password" v-model="formData.new_password" type="password" />
                    <Input v-else v-model="formData.new_password" type="text" />
                    <Icon v-if="password.show_new_password" type="md-eye" @click="toggleNewPassword"></Icon>
                    <Icon type="md-eye-off" v-else @click="toggleNewPassword"></Icon>
                </FormItem>
                <br />

                <FormItem label="Confirm new Password" prop="confirm_password">
                    <Input v-if="!password.show_confirm_password" v-model="formData.confirm_password" type="password" />
                    <Input v-else v-model="formData.confirm_password" type="text" />
                    <Icon v-if="password.show_confirm_password" type="md-eye" @click="toggleConfirmPassword"></Icon>
                    <Icon type="md-eye-off" v-else @click="toggleConfirmPassword"></Icon>
                </FormItem>
                <br />

                <Button type="primary" :loading="isLoading" @click="handleSubmitForm"> Submit </Button>
            </Form>
        </div>
    </Modal>
</template>

<script>
import { userChangePassword } from '@/services/users.services';
import ErrorMessages from '@/components/UI/ErrorMessages';

export default {
    components: {
        ErrorMessages,
    },
    data() {
        return {
            showPassword: false,
            errorMessages: [],
            showModal: false,
            isLoading: false,
            user_id: localStorage.getItem('user_id'),
            formData: {
                old_password: '',
                new_password: '',
                confirm_password: '',
            },
            password: {
                show_old_password: false,
                show_new_password: false,
                show_confirm_password: false,
            },
            formValidate: {
                password: '',
            },
            formRules: {
                old_password: [
                    {
                        required: true,
                        message: 'Please fill in the old password.',
                        trigger: 'blur',
                    },
                ],
                new_password: [
                    {
                        required: true,
                        message: 'Please fill in the new password.',
                        trigger: 'blur',
                    },
                    {
                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*'|])/,
                        message: 'New Password must include lowercase, uppercase, numbers and special characters.',
                        trigger: 'blur',
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (value === '') {
                                callback(new Error('Please input the password again'));
                            } else if (value !== this.formData.confirm_password) {
                                callback(new Error('Confirm password doesnt match'));
                            } else {
                                this.$refs.forgotPasswordForm.validateField('confirm_password');
                                callback();
                            }
                        },
                        trigger: 'blur',
                    },
                ],
                confirm_password: [
                    {
                        required: true,
                        message: 'Please fill in the confirm password.',
                        trigger: 'blur',
                    },
                    {
                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*'|])/,
                        message: 'Confirm Password must include lowercase, uppercase, numbers and special characters.',
                        trigger: 'blur',
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (value === '') {
                                callback(new Error('Please input the password again'));
                            } else if (value !== this.formData.new_password) {
                                callback(new Error('New password doesnt match'));
                            } else {
                                this.$refs.forgotPasswordForm.validateField('new_password');
                                callback();
                            }
                        },
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    methods: {
        toggleOldPassword() {
            this.password.show_old_password = !this.password.show_old_password;
        },
        toggleNewPassword() {
            this.password.show_new_password = !this.password.show_new_password;
        },
        toggleConfirmPassword() {
            this.password.show_confirm_password = !this.password.show_confirm_password;
        },
        openModal() {
            this.showModal = true;
            this.password.show_new_password = false;
            this.password.show_old_password = false;
            this.password.show_confirm_password = false;
        },
        async handleSubmitForm() {
            this.$refs.forgotPasswordForm.validate((valid) => {
                if (valid) {
                    if (this.formData.new_password === this.formData.confirm_password) {
                        this.handleChangePassword();
                    } else {
                        this.$Message.error('Password must match');
                    }
                } else {
                    this.$Message.error('Fill in the required fields');
                }
            });
        },
        handleChangePassword() {
            this.errorMessages = [];
            this.isLoading = true;
            const dataForm = {
                old_password: this.formData.old_password,
                new_password: this.formData.new_password,
            };
            userChangePassword(this.user_id, dataForm)
                .then((res) => {
                    if (res.data) {
                        this.$Message.success('Successfully Change Password');

                        this.isLoading = false;
                        this.handleReset();
                    }
                })
                .catch((err) => {
                    this.$Message.error('Failed to Change Password');
                    this.handleErrorResponse(err.response.data);
                    this.isLoading = false;
                });
        },
        handleErrorResponse(err) {
            if (err.statusCode === 400 && err.message === 'Invalid old password') {
                this.errorMessages.push('Invalid old password');
            }
        },
        handleReset() {
            this.$refs.forgotPasswordForm.resetFields();
            this.isLoading = false;
            this.errorMessages = [];
            this.showModal = false;
        },
    },
};
</script>
<style>
.change-pass-form .ivu-form-item-content {
    margin-left: 0;
}
</style>
